import type {
  BaseSyntheticEvent,
  MutableRefObject,
  PropsWithChildren
} from 'react';
import { createContext, useContext, useRef } from 'react';

export type SubmitFuncType = (
  e?: BaseSyntheticEvent
) => Promise<string | undefined>;

type FormSubmitContextValue = {
  focusCallbackRef: MutableRefObject<(() => void) | undefined>;
  submitCallbackRef: MutableRefObject<SubmitFuncType | undefined>;
};

const FormControllerContext = createContext<FormSubmitContextValue | null>(
  null
);

export function FormControllerProvider({ children }: PropsWithChildren) {
  const focusCallbackRef = useRef<(() => void) | undefined>(undefined);
  const submitCallbackRef = useRef<SubmitFuncType | undefined>(undefined);

  return (
    <FormControllerContext.Provider
      value={{
        focusCallbackRef,
        submitCallbackRef
      }}
    >
      {children}
    </FormControllerContext.Provider>
  );
}

export const useFormController = () => {
  const context = useContext(FormControllerContext);

  if (context === null) {
    throw new Error(
      `useFormController should be used within FormControllerContext`
    );
  }

  return context;
};
